/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vspreviousperiod2Inputs */

const en_vspreviousperiod2 = /** @type {(inputs: Vspreviousperiod2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vs. previous period`)
};

const de_vspreviousperiod2 = /** @type {(inputs: Vspreviousperiod2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vs. Vorperiode`)
};

/**
* | output |
* | --- |
* | "vs. previous period" |
*
* @param {Vspreviousperiod2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const vspreviousperiod2 = /** @type {((inputs?: Vspreviousperiod2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vspreviousperiod2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vspreviousperiod2(inputs)
	return de_vspreviousperiod2(inputs)
});
export { vspreviousperiod2 as "vsPreviousPeriod" }